<template>
  <el-row :gutter="20" v-if="mode == 'create'">
    <el-col :span="6" style="text-align: left;">
      <el-button type="info" round :icon="FolderAdd" @click="dialog = true">添加产品</el-button>
    </el-col>
  </el-row>
  <el-button v-if="mode == 'update'"  plain size="small" type="success"  @click="dialog = true; findProject()">编辑</el-button>

  <el-dialog v-model="dialog" :close-delay="300" width="800px" top="0vh" center :modal="false"
             :close-on-click-modal="false"
  >
    <template #header>
      <p style="letter-spacing: 1px;">
        <el-tag size="large" round type="success" effect="plain" style="--el-tag-font-size: 15px;">
          <el-icon v-if="mode == 'update'">
            <Edit/>
          </el-icon >
          <el-icon v-else>
            <FolderAdd/>
          </el-icon>
          {{mode == 'update' ? '编辑产品' : '添加产品'}}
        </el-tag>
      </p>
    </template>
    <div>
      <el-input v-model="projectInfo.pcode"  placeholder="请输入产品品号"  show-word-limit maxlength="40">
        <template #prepend>
          <div style="width: 100px;text-align: center">产品品号 <span style="color: #FF0000">*</span></div>
        </template>
      </el-input>
      <el-tag type="danger" effect="plain"  style="margin-left: 140px;visibility: hidden" :style="errorData.name === 'pcode' ? 'visibility: visible' : ''"  size="small" round  >{{errorData.message}}</el-tag>
    </div>

    <div style="margin-top: 5px">
      <el-input v-model="projectInfo.pname"  placeholder="请输入产品名称" show-word-limit maxlength="10">
        <template #prepend>
          <div style="width: 100px;text-align: center">产品名称<span style="color: #FF0000">*</span></div>
        </template>
      </el-input>
      <el-tag type="danger"  effect="plain" style="margin-left: 140px;visibility: hidden" :style="errorData.name === 'pname' ? 'visibility: visible' : ''"  size="small" round  >{{errorData.message}}</el-tag>
    </div>
    <div style="margin-top: 5px">
      <el-input v-model="projectInfo.pmodel"  placeholder="请输入产品规格型号" show-word-limit maxlength="14">
        <template #prepend>
          <div style="width: 100px;text-align: center">产品规格型号<span style="color: #FF0000">*</span></div>
        </template>
      </el-input>
      <el-tag type="danger" effect="plain" style="margin-left: 140px;visibility: hidden" :style="errorData.name === 'pmodel' ? 'visibility: visible' : ''"  size="small" round  >{{errorData.message}}</el-tag>
    </div>
    <div style="margin-top: 5px">
      <el-input v-model="projectInfo.amount"  placeholder="请输入出库数量" show-word-limit maxlength="12">
        <template #prepend>
          <div style="width: 100px;text-align: center">出库数量<span style="color: #FF0000">*</span></div>
        </template>
      </el-input>
      <el-tag type="danger" effect="plain" style="margin-left: 140px;visibility: hidden" :style="errorData.name === 'amount' ? 'visibility: visible' : ''"  size="small" round  >{{errorData.message}}</el-tag>
    </div>
    <div style="margin-top: 5px">
      <el-input v-model="projectInfo.remark"  placeholder="请输入备注" show-word-limit maxlength="14">
        <template #prepend>
          <div style="width: 100px;text-align: center">备注</div>
        </template>
      </el-input>
      <el-tag type="danger" effect="plain" style="margin-left: 140px;visibility: hidden" :style="errorData.name === 'remark' ? 'visibility: visible' : ''"  size="small" round  >{{errorData.message}}</el-tag>
    </div>
    <template #footer>
      <el-button type="success" plain @click="onCreateProject" style="width: 90%" round :icon="FolderAdd" v-if="mode == 'create'">
        添加
      </el-button>
      <el-button type="success" plain @click="onUpdateProject" style="width: 90%" round :icon="Edit" v-if="mode == 'update'">
        更新
      </el-button>
      <div class="Page" style="height: 120px">
        <div class="container" style="width: 20cm;margin-left: -1.5cm;">
          <h1 style="text-align: center;font-size: 19px;color: #67c23a;padding-bottom: 10px">预览输入内容</h1>
          <table width="755" style="width: 755px;margin: 0 auto;border-collapse: collapse;text-align: center;color: #000;">
            <tbody>
            <tr>
              <td style="border: 1px solid #333;padding: 4px 7px;width: 80px" width="80">序号</td>
              <td style="border: 1px solid #333; border-left: none;padding: 4px 7px;width: 350px" width="350">产品品号</td>
              <td style="border: 1px solid #333; border-left: none;padding: 4px 7px;width: 100px" width="100">产品名称</td>
              <td style="border: 1px solid #333; border-left: none;padding: 4px 7px;width: 120px" width="120">产品规格型号</td>
              <td style="border: 1px solid #333; border-left: none;padding: 4px 7px;width: 80px" width="80">数量</td>
              <td style="border: 1px solid #333; border-left: none;padding: 4px 7px;width: 130px" width="130">备注</td>
            </tr>
            <tr>
              <td style="border: 1px solid #333;padding: 4px 7px;width: 80px" width="80">1</td>
              <td style="border: 1px solid #333; border-left: none;padding: 4px 7px;width: 350px" width="350">{{projectInfo.pcode}}</td>
              <td style="border: 1px solid #333; border-left: none;padding: 4px 7px;width: 100px" width="100">{{projectInfo.pname}}</td>
              <td style="border: 1px solid #333; border-left: none;padding: 4px 7px;width: 120px" width="120">{{projectInfo.pmodel}}</td>
              <td style="border: 1px solid #333; border-left: none;padding: 4px 7px;width: 80px" width="80">{{projectInfo.amount}}</td>
              <td style="border: 1px solid #333; border-left: none;padding: 4px 7px;width: 130px" width="130">{{projectInfo.remark}}</td>
            </tr>
            <!--        固定表格结构-->
            <tr style="visibility: hidden;color: transparent">
              <td style="border: 1px solid transparent;border-top: none;padding: 4px 7px;width: 80px" width="80">ABCDEFGH</td>
              <td style="border: 1px solid transparent; border-left: none;border-top: none;padding: 4px 7px;width: 350px" width="350">ABCDEFGHGHABCDEFGHGHABCDEFGHGHABCDEFGHGH</td>
              <td style="border: 1px solid transparent; border-left: none;border-top: none;padding: 4px 7px;width: 100px" width="100">ABCDEFGHGH</td>
              <td style="border: 1px solid transparent; border-left: none;border-top: none;padding: 4px 7px;width: 120px" width="120">ABCDEFGHGHGHGH</td>
              <td style="border: 1px solid transparent; border-left: none;border-top: none;padding: 4px 7px;width: 80px" width="80">ABCDEFGH</td>
              <td style="border: 1px solid transparent; border-left: none;border-top: none;padding: 4px 7px;width: 130px" width="130">ABCDEFGHGHGHGH</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>


    </template>
  </el-dialog>
</template>

<script setup>
import {Edit, FolderAdd} from '@element-plus/icons-vue';
import {defineEmits, reactive, ref, defineProps, watch} from "vue";
import {configObjectNull, get, post} from "@/assets/js/utils";
const props = defineProps(['mode', 'id'])
const dialog = ref(false)
const emits = defineEmits(['search', 'createdProject', 'updatedProject'])
const projectInfo = reactive({
  pcode: null,
  pname: null,
  pmodel: null,
  amount: null,
  remark: null,
})

watch(projectInfo, () => {
  errorData.name = ''
})

const errorData = reactive({
  name:'',
  message: ''
})


const onCreateProject = function () {
  let postData = {...projectInfo, odo_id: props.id};
  post('/item/add', postData, ({message, code, data}) => {
    // ElMessage({
    //   message,
    //   type: code == 0 ? 'success' : 'info',
    //   duration: 10000
    // })
    if (code != 0){
      errorData.name = data.data;
      errorData.message = message;
      return;
    }
    emits("createdProject")
    configObjectNull(projectInfo, ['report_spec'])
    dialog.value = false;

  },null)
}


const onUpdateProject = function () {
  let postData = {...projectInfo,id: props.id};
  post('/item/update', postData, ({message, code, data}) => {
    // ElMessage({
    //   message,
    //   type: code == 0 ? 'success' : 'info',
    //   duration: 10000
    // })
    if (code != 0){
      errorData.name = data.data;
      errorData.message = message;
      return;
    }
    emits("updatedProject")
    configObjectNull(projectInfo)
    dialog.value = false;

  },null)
}

function findProject(){
  get('/item/list?id=' + props.id, ({code, data}) => {
    if (code == 0){
      Object.assign(projectInfo, data.data.list[0]);
    }
  })
}


</script>

<style scoped>

</style>